export default function Reducer(state, action) {
  switch (action.type) {
    case 'LOAD':
      return {
        ...state,
        workflow: action.data.attributes.workflow,
        steps: action.data.attributes.steps.map((item) => item.steps).flat().map((item) => ({
          ...item,
          completed: action.data.attributes.completed_steps.includes(item.step),
        })),
        onboardingStatus: action.data.attributes.status,
        currentStep: 0, // TODO: change to 0
        isFirstOnboarding: action.data.attributes.completed_steps.length === 0,
        programId: action.data.attributes.program_id,
        isSecondProgramOnboarding: action.data.attributes.is_second_program_onboarding,
      };
    case 'NEXT_STEP':
      return {
        ...state,
        currentStep: action.nextStep,
      };
    case 'PREV_STEP':
      return {
        ...state,
        currentStep: action.prevStep,
      };
    default:
      throw Error(`Unknown action: ${action.type}`);
  }
}
